import { ApiResponse, request } from './base';
import * as models from '../../models'; 
import utils from '../../utils'; 

export const addContactSimple = async (contact: models.ContactSimple) => {
  const response = await request ({
    method: 'POST',
    url: `/Contacts/simple`,
    data: contact
  }); 
  return response; 
}

export const createContact = async (contact: models.Contact) => {
  const response = await request ({
    method: 'POST',
    url: `/Contacts`,
    data: contact
  }); 
  return response; 
}

export const getConnectAdjuster = async (contactId: number) => {
  const response = await request ({
    method: 'GET',
    url: `/Contacts/sync/${contactId}`
  }); 
  return response; 
}

export const getContacts = async (contactRequest: models.ContactsRequest) => {  
  var qStr = utils.helpers.encodeQueryString(contactRequest); 

  const response = await request ({
    method: 'GET', 
    url: `/Contacts?${qStr}`, 
  }); 
  return response; 
}; 

export const getContactsCSV = async (contactsRequest: models.ContactsRequest) => {
    var qStr = utils.helpers.encodeQueryString(contactsRequest);     
    const response = await request ({
        method: 'GET',
        url: `/contacts/export?${qStr}`, 
    });     
    if (response.isSuccess) {
        const responseData = await utils.filehelpers.readAsDataURL(new Blob([response.data], {type: "application/csv"}));
        try {
            utils.filehelpers.downloadFile(response);

        } catch (err) {
            return {
                error: err,
              };
        }     
    return true; 
    }
    else {
        console.log(response); 
    }
}

export const getContactAudits = async (payload: models.ContactSpecificAuditLogSearch) => {
  var qStr = utils.helpers.encodeQueryString(payload);     
  const response = await request ({
    method: 'GET', 
    url: `/contacts/${payload.contactId}/auditLogs?${qStr}`,     
  }); 
  return response; 
}

export const getContactDupes = async (contactId: number) => {  
  const response = await request ({
    method: 'GET', 
    url: `/contacts/${contactId}/dupes`,
  }); 
  return response; 
}

export const mergeContacts = async (contactId: number, payload: object) => {  
  const response = await request ({
    method: 'POST', 
    url: `/contacts/${contactId}/merge`,
    data: { duplicateContactIds: payload }
  }); 
  return response; 
}

export const syncContact = async (id: number) => {
  return await request({
      method: 'POST',
      url: `/contacts/${id}/sync`,
  }); 
}

export const updateContact = async (contactId: number, patch: object) => {
  return await request({
      method: 'PATCH',
      url: `/contacts/${contactId}`,
      headers: {
          'Content-Type': 'application/json-patch+json'
      }, 
      data: patch,
  }); 
}

export const getContactMethods = async (id: number) => {
  return await request({
      method: 'GET',
      url: `/contacts/${id}/contactMethods`,      
  }); 
}

// dropdowns
export const getAdjusters = async () => {
  return await request({
      method: 'GET',
      url: `/contacts/adjusters`,      
  }); 
}

export const getCompanyExaminers = async (companyName: string) => {
  return await request({
      method: 'GET',
      url: `/contacts/companyExaminers/${companyName}`,      
  }); 
}

export const getExaminers = async () => {
  return await request({
      method: 'GET',
      url: `/contacts/examiners`,      
  }); 
}

export const getFieldDirectors = async () => {
  return await request({
      method: 'GET',
      url: `/contacts/fieldDirectors`,      
  }); 
}

export const getReviewers = async () => {
  return await request({
      method: 'GET',
      url: `/contacts/reviewers`,      
  }); 
}